<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->

<template>
    <div class="min-h-screen bg-gray-50 p-8">
      <!-- 头部标题区域 -->
      
      <div class="mb-8">
        <h1 class="text-3xl font-bold text-gray-800 mb-4">(只计算已收货完成订单)</h1>
        <div class="flex items-center gap-4">
          <button class="!rounded-button bg-white border border-gray-200 px-4 py-2 flex items-center gap-2 hover:bg-gray-50">
            <i class="fas fa-calendar-alt text-gray-600"></i>
            <span>最近 30 天</span>
            <i class="fas fa-chevron-down text-gray-600 ml-2"></i>
          </button>
        </div>
      </div>



      <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
        <div class="flex justify-between items-center">
          <div class="flex items-center gap-4">
            <!-- 供应商下拉选择 -->
            <div class="relative"  v-if="isuse == 1">
              <button @click="toggleSupplierDropdown" class="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700 hover:bg-gray-50">
                <i class="fas fa-building"></i>
                <span class="whitespace-nowrap">{{ selectedSupplier.name || '选择供应商' }}</span>
                <i class="fas fa-chevron-down text-gray-400"></i>
              </button>
              <div v-if="showSupplierDropdown" class="absolute z-10 w-56 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                <div class="py-2">
                  <div v-for="item in supply" :key="item.supply_id" @click="selectSupplier(item)" class="px-4 py-2 hover:bg-gray-50 cursor-pointer">
                     {{item.name}}
                  </div>
                </div>
              </div>
            </div>
            
            <!-- 日期范围选择 -->
            <!-- <div class="flex items-center gap-2">
              <input type="date" v-model="form.startDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
              <span class="text-gray-500">至</span>
              <input type="date" v-model="form.endDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
            </div> -->
          </div>

        
        <button  @click="search" class="px-6 py-2 bg-blue-600 text-white rounded-button hover:bg-blue-700 flex items-center gap-2">
             
                <span class="whitespace-nowrap">查询</span>
          </button>
          

        </div>
      </div>


  
      <!-- 数据概览卡片 -->
      <div class="grid grid-cols-4 gap-6 mb-8">
        <div v-for="(card, index) in cards" :key="index" 
             class="bg-white rounded-lg p-6 shadow-sm">
          <div class="flex justify-between items-start mb-2">
            <span class="text-gray-600">{{ card.title }}</span>
            <i :class="['fas', card.icon, 'text-blue-500']"></i>
          </div>
          <div class="text-2xl font-bold text-gray-800 mb-2">{{ card.value }}</div>
          <div :class="['flex items-center', card.increase > 0 ? 'text-green-500' : 'text-red-500']">
            <i :class="['fas', card.increase > 0 ? 'fa-arrow-up' : 'fa-arrow-down', 'mr-1']"></i>
            <span>{{ Math.abs(card.increase) }}%</span>
            <span class="text-gray-500 ml-2">环比</span>
          </div>
        </div>
      </div>
  
      <!-- 趋势图表区域 -->
      <div class="bg-white rounded-lg p-6 shadow-sm mb-8">
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-xl font-bold text-gray-800">进货趋势分析</h2>
          <div class="flex gap-4">
            <!-- <button class="!rounded-button bg-blue-50 text-blue-600 px-4 py-2 whitespace-nowrap">按月</button>
            <button class="!rounded-button bg-gray-100 text-gray-600 px-4 py-2 whitespace-nowrap">按周</button> -->
          </div>
        </div>
        <div ref="chartRef" style="height: 400px"></div>
      </div>
  
      <!-- 经营详情列表 -->
      <div class="bg-white rounded-lg shadow-sm">
        <div class="p-6 border-b border-gray-100">
          <div class="flex justify-between items-center">
            <h2 class="text-xl font-bold text-gray-800">进货记录</h2>
            <div class="flex gap-4">
            </div>
          </div>
        </div>
        <div class="overflow-x-auto">
          <table class="w-full">
            <thead class="bg-gray-50">
              <tr>
                <th v-for="header in tableHeaders" :key="header" 
                    class="px-6 py-4 text-left text-sm font-medium text-gray-600">
                  {{ header }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in tableData" :key="index" 
                  class="border-t border-gray-100 hover:bg-gray-50">
                <td v-for="(value, key) in row" :key="key" 
                    class="px-6 py-4 text-sm text-gray-700">
                  <div :class="{'text-blue-600': key === 'orderNo', 
                               'text-green-500': value === '已完成',
                               'text-yellow-500': value === '进行中'}">
                    {{ value }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>


          <div class="pagination">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background :current-page="curPage"
            :page-sizes="[20, 100,500, 1000]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="totalDataNumber"></el-pagination>
        </div>
        </div>
      </div>
  

    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  import UserApi from '@/api/user.js';

  import StatisticsApi from '@/api/statistics.js';
  export default {
    data() {
      return {
        selectedSupplier: {'name':""},
        showSupplierDropdown: false,
        startDate: '',
        endDate: '',
        supply:[],
        form:{
            startDate: '',
            endDate: '',
        },
        isuse:0,
        statistics:[],
        cards: [
  
        ],
        tableHeaders: ['订单编号', '日期', '商品名称', '数量', '单价', '供应商', '状态'],
        tableData: [
        ],
          /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        form:{}
      };
    },
    mounted() {
               /*获取数据*/
               var self = this;
      self.getInas({},function(res){
        self.isuse = res
      })
      self.getSupplys()
      self.search();
     
    },
    methods: {
      search(){
        this.getTotalPurchaseAmount()
        this.getTotalOrderCount()
        this.getCooperationSuppliers()
        this.getAverageOrderPrice()
        this.getPurchaseTrend()
        this.getPurchaseRecords()
      },
      getSupplys(){
            let self = this;
    
    
            // UserApi.getSupply({}, true)
            //     .then(data => {
              
            //     self.supply = data.data.supply
           
            //     })
            //     .catch(error => {
            //     });
        },
        toggleSupplierDropdown() {
        this.showSupplierDropdown = !this.showSupplierDropdown;
      },
      selectSupplier(supplier) {
        this.selectedSupplier = supplier;
        this.showSupplierDropdown = false;
        this.form.supply_id = supplier.supply_id
      },
      handleDateChange() {
        if (this.startDate && this.endDate) {
          this.refreshData();
        }
      },
      toggleWholesaleDropdown() {
        this.showWholesaleDropdown = !this.showWholesaleDropdown;
        this.showTimeDropdown = false;
        this.showStoreDropdown = false;
      },
      toggleStoreDropdown() {
        if (this.selectedWholesale) {
          this.showStoreDropdown = !this.showStoreDropdown;
          this.showWholesaleDropdown = false;
        }
      },
          /*选择第几页*/
        handleCurrentChange(val) {
        this.curPage = val
        this.getPurchaseRecords()
        },
        /*每页多少条*/
        handleSizeChange(val) {
        this.curPage = 1
        this.pageSize = val
        this.getPurchaseRecords()
        },
        getTotalPurchaseAmount(){
            let self = this;
            StatisticsApi.getTotalPurchaseAmount(self.form, true)
            .then(res => {
                self.cards[0]  = res.data
            })
            .catch(error => {});
        },
        getTotalOrderCount(){
            let self = this;
            StatisticsApi.getTotalOrderCount(self.form, true)
            .then(res => {
                self.cards[1]  = res.data
            })
            .catch(error => {});
        },
        getCooperationSuppliers(){
            let self = this;
            StatisticsApi.getCooperationSuppliers(self.form, true)
            .then(res => {
                self.cards[2]  = res.data
            })
            .catch(error => {});
        },
        getAverageOrderPrice(){
            let self = this;
            StatisticsApi.getAverageOrderPrice(self.form, true)
            .then(res => {
                self.cards[3]  = res.data
            })
            .catch(error => {});
        },
        getPurchaseTrend(){
            let self = this;
            const chart = echarts.init(this.$refs.chartRef);
            StatisticsApi.getPurchaseTrend(self.form, true)
            .then(res => {

                chart.setOption(res.data);
            })
            .catch(error => {});
        },
        getPurchaseRecords(){
            let self = this;
            let Params = self.form
            Params.page = self.curPage
            Params.list_rows = self.pageSize
            StatisticsApi.getPurchaseRecords(Params, true)
            .then(res => {
                self.tableData  = res.data.data
                self.totalDataNumber = res.data.total;
            })
            .catch(error => {});
        },

      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  };
  </script>
  
  <style scoped>
  .table-container {
    overflow-x: auto;
  }
  </style>
  
  


// WEBPACK FOOTER //
// src/views/user/saless/index.vue